import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import {AiOutlineMail} from "react-icons/ai";
import { useTranslation } from "react-i18next";
import LofoFalcon from "../Assets/Falcon FPV.webp";
import { NavLink, useLocation, useHistory } from "react-router-dom"; // Importa useLocation

function NavBar() {
   const { t, i18n } = useTranslation();
   const [expand, updateExpanded] = useState(false);
   const [navColour, updateNavbar] = useState(false);
   const [backGround, updateBackground] = useState(false);
   const [activeNav, setActiveNav] = useState("");
   const [language, setLanguage] = useState("es"); // Estado para la bandera (español por defecto)
   const location = useLocation(); // Obtiene la ruta actual
   const history = useHistory();
   const isEnglish = location.pathname.startsWith("/en");
   const basePath = i18n.language === "en" ? "/en" : "";

   const serviceRoutes = [
      "/fotografia-aerea",
      "/drones-inmobiliaria",
      "/grabacion-eventos-dron",
      "/inspections",
      "/grabacion-fpv",
      "/politica-privacidad",
      "/condiciones",
      "/servicios-drones",
      "/cookies",
      "/sobre-mi"
   ];

   const privacyPolicy = [
      "/politica-privacidad",
      "/condiciones",
      "/cookies",
      "/aviso-legal"
   ];

   const rawPath = location.pathname;
   const normalizedPath = rawPath.startsWith("/en")
      ? rawPath.replace("/en", "") || "/"
      : rawPath;

   const isServicePage = serviceRoutes.includes(normalizedPath);
   const isWorksPage =
      normalizedPath.startsWith("/trabajos") || normalizedPath === "/drones";
   const isPrivacyPolicyPage = privacyPolicy.includes(normalizedPath);

   useEffect(() => {
      const storedLanguage = localStorage.getItem("selectedLanguage");
      if (storedLanguage) {
         setLanguage(storedLanguage);
         i18n.changeLanguage(storedLanguage);
      }
      const scrollHandler = () => {
         if (window.scrollY >= 20) {
            updateNavbar(true);
            updateBackground(true);
         } else {
            updateNavbar(false);
            updateBackground(false);
         }

         // Define section positions
         const sections = ["skills", "aboutme", "testimonials", "fleet", "contact"];
         let currentSection = "";

         for (let i = sections.length - 1; i >= 0; i--) {
            const section = document.getElementById(sections[i]);
            if (
               section &&
               window.scrollY + window.innerHeight / 2 >= section.offsetTop
            ) {
               currentSection = sections[i];
               break;
            }
         }

         setActiveNav(currentSection);
      };

      window.addEventListener("scroll", scrollHandler);

      // Cleanup the event listener on unmount
      return () => {
         window.removeEventListener("scroll", scrollHandler);
      };
   }, []);

   const handleNavClick = (sectionId) => {
      setActiveNav(sectionId);
      updateExpanded(false);
      const section = document.getElementById(sectionId);
      if (section) {
         section.scrollIntoView({ behavior: "smooth" });
      }
   };

   const toggleLanguage = () => {
      const newLanguage = language === "es" ? "en" : "es";

      i18n.changeLanguage(newLanguage);
      localStorage.setItem("selectedLanguage", newLanguage);
      setLanguage(newLanguage);

      const currentPath = location.pathname;

      if (newLanguage === "en") {
         if (!currentPath.startsWith("/en")) {
            history.push("/en" + currentPath);
         }
      } else {
         if (currentPath.startsWith("/en")) {
            history.push(currentPath.replace("/en", "") || "/");
         }
      }
   };

   useEffect(() => {
      if (location.pathname.startsWith("/en")) {
         i18n.changeLanguage("en");
         setLanguage("en");
      } else {
         i18n.changeLanguage("es");
         setLanguage("es");
      }
   }, [location.pathname]);

   const localizedPath = (path) => {
      if (isEnglish) {
         return "/en" + (path.startsWith("/") ? path : "/" + path);
      }
      return path;
   };

   const handleToggleClick = () => {
      updateExpanded(!expand);
      updateBackground(!backGround); // Cambia el estado de backGround
   };

   const handleToggleProjects = () => {
      updateBackground(false);
      updateExpanded(false);
   }

   return (
      <Navbar
         expanded={expand}
         fixed="top"
         expand="xl"
         className={navColour ? "sticky" : "navbar"}
         id={backGround ? "backGroundNavbar" : ""}
      >
         <Navbar.Brand
            href={
               isServicePage || isWorksPage || isPrivacyPolicyPage
                  ? `${basePath}/`
                  : "#home"
            }
            title="Home"
         >
            <img
               src={LofoFalcon}
               className="logo"
               alt="brand"
               title="Logo Falcon"
               style={{}}
               loading="eager"
            />
         </Navbar.Brand>
         <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={handleToggleClick} // Agrega el manejador de eventos aquí
         >
            <span></span>
            <span></span>
            <span></span>
         </Navbar.Toggle>
         <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ml-auto">
               <Nav.Item>
                  <Nav.Link
                     onClick={toggleLanguage}
                     style={{ cursor: "pointer" }}
                     title={
                        language === "es"
                           ? "Cambiar a inglés"
                           : "Switch to Spanish"
                     }
                  >
                     <div className="lang-container">
                        <span>{language === "es" ? "ES |" : "EN |"} </span>
                        {/* <Flag
                           code={language === "es" ? "es" : "gb"}
                           className="lang-flag"
                           alt="Language flag"
                           title="Language flag"
                        /> */}
                        <img
                           src={`https://flagcdn.com/w80/${
                              language === "es" ? "es" : "gb"
                           }.webp`}
                           alt="Language flag"
                           className="lang-flag"
                           loading="lazy" // 🔹 Lazy load aquí
                        />
                     </div>
                  </Nav.Link>
               </Nav.Item>
               {!(isServicePage || isWorksPage) && (
                  <>
                     <Nav.Item>
                        <Nav.Link
                           href="#"
                           title="Services"
                           onClick={(e) => {
                              e.preventDefault();
                              handleNavClick("skills");
                           }}
                           className={activeNav === "skills" ? "act" : ""}
                        >
                           {t("services")}
                        </Nav.Link>
                     </Nav.Item>
                     <Nav.Item>
                        <Nav.Link
                           href="#"
                           title="About"
                           onClick={(e) => {
                              e.preventDefault();
                              handleNavClick("aboutme");
                           }}
                           className={activeNav === "aboutme" ? "act" : ""}
                        >
                           {t("my_history")}
                        </Nav.Link>
                     </Nav.Item>
                     {/* Opiniones */}
                     <Nav.Item>
                        <Nav.Link
                           href="#"
                           title="Testimonials"
                           onClick={(e) => {
                              e.preventDefault();
                              handleNavClick("testimonials");
                           }}
                           className={activeNav === "testimonials" ? "act" : ""}
                        >
                           {t("opiniones")}
                        </Nav.Link>
                     </Nav.Item>
                     <Nav.Item>
                        <Nav.Link
                           as={NavLink}
                           to={localizedPath("/trabajos")}
                           title="Works"
                           className={activeNav === "works" ? "act" : ""}
                           onClick={handleToggleProjects}
                        >
                           {t("works")}
                        </Nav.Link>
                     </Nav.Item>
                     <Nav.Item>
                        <Nav.Link
                           // href="#"
                           as={NavLink}
                           to={localizedPath("/drones")}
                           title="Fleet & Technology"
                           // onClick={(e) => {
                           //    e.preventDefault();
                           //    handleNavClick("fleet");
                           // }}
                           onClick={handleToggleProjects}
                           className={activeNav === "fleet" ? "act" : ""}
                        >
                           {t("equipo_tecnologia")}
                        </Nav.Link>
                     </Nav.Item>
                  </>
               )}

               {(isServicePage || isWorksPage) && (
                  <>
                     <Nav.Item>
                        <Nav.Link
                           as={NavLink}
                           to={localizedPath("/")}
                           title="Home"
                           onClick={handleToggleProjects}
                        >
                           {t("home")}
                        </Nav.Link>
                     </Nav.Item>
                  </>
               )}
               {isServicePage && (
                  <>
                     <Nav.Item>
                        <Nav.Link
                           as={NavLink}
                           to={localizedPath("/trabajos")}
                           title="Trabajos"
                           className={activeNav === "works" ? "act" : ""}
                           onClick={handleToggleProjects}
                        >
                           {t("works")}
                        </Nav.Link>
                     </Nav.Item>
                  </>
               )}
               {!isPrivacyPolicyPage && (
                  <>
                     <Nav.Item>
                        <Nav.Link
                           href="#"
                           title="Contact"
                           onClick={(e) => {
                              e.preventDefault();
                              handleNavClick("contact");
                           }}
                           className={activeNav === "contact" ? "act" : ""}
                        >
                           <AiOutlineMail
                              style={{
                                 marginBottom: "2px",
                                 marginRight: "2px",
                              }}
                           />{" "}
                           {t("contact")}
                        </Nav.Link>
                     </Nav.Item>
                  </>
               )}
            </Nav>
         </Navbar.Collapse>
      </Navbar>
   );
}

export default NavBar;
